const initialState = {
  page: null,
  params: {},
};

const reductions = {
  SET_PAGE: function (state, action) {
    return Object.assign({}, state, { page: action.payload });
  },
  SET_PARAMS: function (state, action) {
    return Object.assign({}, state, { params: action.payload });
  },
  SET_SLUG: function (state, action) {
    return Object.assign({}, state, { slug: action.payload });
  },
};

const locationReducer = (state = initialState, action) => {
  if (action && action.type && reductions[action.type]) {
    return reductions[action.type](state, action);
  }
  return state;
};

export default locationReducer;
